import { createContext } from 'react';

/** @typedef {import('@tesla/react-context-form/types/hooks/useFormField').FormFieldState} FormFieldState */

/**
 * @typedef {Object} OptionGroupContextAttributes
 * @property {*} value
 * @property {Boolean} disabled
 * @property {Boolean} multiselect
 * @property {String} name
 * @property {String} id
 *
 * @typedef {Object} OptionGroupContext
 * @property {FormFieldState & OptionGroupContextAttributes} optionGroupContext
 * @property {Object} optionGroupHandler
 */
var OptionGroupContext =
/*#__PURE__*/
/** @type {React.Context<OptionGroupContext | undefined>} */
createContext(undefined);

/**
 * @typedef {Object} RadioGroupContext
 * @property {FormFieldState} radioGroupContext
 * @property {Object} radioGroupHandler
 * @property {String} radioGroupHandler.id
 */
var RadioGroupContext =
/*#__PURE__*/
/** @type {React.Context<RadioGroupContext | undefined>} */
createContext(undefined);

export { OptionGroupContext, RadioGroupContext };
